import React from 'react';
import { withStyles, Grid, Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

const ICON = require("../../images/icons/hotremmend.png");


class LiveValidity extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            curtime: LiveValidity.getCurTime(),
        }
    }

    static getCurTime() {
        let now = new Date();
        let month = now.getMonth() + 1;
        let day = now.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return month + '月' + day + '日';
    }

    render() {
        const { classes } = this.props;
        const { curtime } = this.state;
        return (
            <Grid container alignItems='center' className={classes.root}>
                <Grid container direction='column' alignItems='center' justifyContent='space-between' className={classes.container}>
                    <Grid container alignItems='center' justifyContent='center' className={classes.titleContainer}>
                        <Typography className={classes.title} >{curtime}</Typography>
                    </Grid>
                    <Grid container alignItems='center' justifyContent='center' className={classes.content} >
                        <img src={ICON} className={classes.icon}></img>
                    </Grid>
                    <Grid className={classes.diverLine} />
                    <Grid container alignItems='center' justifyContent='center' className={classes.bottom}>
                        <Typography className={classes.title}>{this.props.data + "场"}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: 70,
        height: 86,
        border: 1,
        backgroundColor: 'tansparent',
        borderRadius: 8,
    },
    container: {
        width: 70,
        height: 86,
        border: 1,
        backgroundColor: '#F5F5F5',
        borderRadius: 8,
    },
    title: {
        color: '#0D0D0D',
        fontSize: 12,
    },
    titleContainer: {
        height: 24,
        flex: 1,
    },
    content: {
        backgroundColor: '#FFF',
        width: 68,
        height: 37,
    },
    diverLine: {
        height: 1,
    },
    icon: {
        width: 30,
        height: 30,
    },
    bottom: {
        height: 23,
        width: 68,
        backgroundColor: '#FFF',
        marginBottom: 1,
    }

}))(LiveValidity));